<template>
  <v-app-bar app flat class="secondary--background-color secondary--border-bottom" color="white" height="64">
      <v-row no-gutters justify="end">
        
        <v-col cols="auto">
          <div class="d-flex align-center">
            <div v-if="getUser" class="email-display mr-4">
              <v-icon small class="mr-1">mdi-account-circle</v-icon>
              <span class="text-body-2 font-weight-medium">{{ getUser.name }}</span>
              <span v-if="getUser.email" class="text-body-2 ml-1">| {{ getUser.email }}</span>
            </div>
            <div v-if="isAdmin && getTenant" class="tenant-display mr-4">
              <span class="text-body-2 font-weight-bold">Tenant:</span>
              <span class="text-body-2 ml-1">{{ getTenant }}</span>
            </div>
            <v-btn v-if="!isAdmin" class="mr-4" small color="primary" @click="openEmailDialog">{{ $t('action.editEmail') }}<v-icon class="ml-2" small>mdi-email</v-icon></v-btn>
            <v-btn class="mr-12" small color="primary" @click="logoutDialog = true">Logout<v-icon class="ml-2" small>mdi-logout</v-icon></v-btn>
          </div>
        </v-col>
      </v-row>
    <v-dialog v-model="logoutDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline align-self-center text-center">Are you sure you want to logout?</v-card-title>
        <v-card-actions>
          <v-btn color="primary" text @click="handleLogout">Yes</v-btn>
          <v-btn color="red" text @click="logoutDialog = false;">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline align-self-center text-center">{{ $t('email.title') }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="emailAddress"
            :placeholder="$t('email.placeholder')"
            :error-messages="emailError"
            outlined
            dense
            @input="validateEmail"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="closeEmailDialog">{{ $t('action.cancel') }}</v-btn>
          <v-btn 
            color="primary" 
            text 
            :disabled="!emailValid"
            @click="handleUpdateEmail"
          >
            {{ $t('action.update') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppBar',
  computed: {
    ...mapGetters(["getUser", "getTenant"]),
    isAdmin() {
      return this.getUser && this.getUser.name === 'admin';
    },
    emailRegex() {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    }
  },
  data: function() {
    return {
      searchTerm: null,
      logoutDialog: false,
      emailDialog: false,
      emailAddress: '',
      emailError: '',
      emailValid: false
    };
  },
  methods: {
    ...mapActions(['logout', 'updateEmail']),
    async handleLogout() {
      await this.logout();
      this.logoutDialog = false;
    },
    validateEmail() {
      if (this.emailAddress && !this.emailRegex.test(this.emailAddress)) {
        this.emailError = this.$t('email.invalid');
        this.emailValid = false;
      } else {
        this.emailError = '';
        this.emailValid = this.emailAddress && this.emailRegex.test(this.emailAddress);
      }
    },
    async handleUpdateEmail() {
      if (!this.emailValid) return;
      
      const updateData = {
        email: this.emailAddress
      };
      
      const result = await this.updateEmail(updateData);
      if (result.success) {
        this.$toast.success(this.$t('email.updateSuccess'));
        this.closeEmailDialog();
      } else {
        this.$toast.error(result.error || this.$t('email.updateError'));
      }
    },
    closeEmailDialog() {
      this.emailDialog = false;
      this.emailAddress = '';
      this.emailError = '';
      this.emailValid = false;
    },
    openEmailDialog() {
      this.emailDialog = true;
    }
  }
}
</script>
<style scoped>
.secondary--background-color {
  background-color: var(--v-background-base);
}

.secondary--border-bottom::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #F5F5F5;
}

.email-display {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 6px 12px;
  border-radius: 16px;
  color: #666;
}

.tenant-display {
  display: flex;
  align-items: center;
  background-color: #e3f2fd;
  padding: 6px 12px;
  border-radius: 16px;
  color: #1976d2;
}
</style>